import { useGetGameCreativeDetailsQuery } from '../../../api/ua-insights'
import { useUAInsightsScope } from './useUAInsightsNavigation'

export const useGameCreativeDetails = (gameId: string | null) => {
  const { networkId, month } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetGameCreativeDetailsQuery(
    { gameId: gameId ?? '', networkId: networkId ?? undefined, month: month ?? undefined },
    { skip: !gameId }
  )
  return { data, isLoading: isFetching, isError, refetch }
}
